// import Swiper bundle with
import MVGL from "./webgl/webgl.es6";
import Stage from "./stage.es6";
import MainScroll from "./scroll.es6";

export default class Main {
  constructor() {
    this.mvgl = new MVGL(document.querySelector(".mv_gl"));
    this.stage = new Stage();
    this.mainScroll = new MainScroll();
    this.init();
  }

  init() {
    this.setVariables();
  }

  setVariables() {
    const stageInner = document.querySelector(".js-stageinner");
    const stageOuter = document.querySelector(".js-stageouter");

    const setCss = () => {
      const w = stageOuter.offsetWidth - stageInner.clientWidth;
      document.documentElement.style.setProperty("--stageSideWidth", w + "px");
    };

    const onReseize = () => {
      setCss();
    };

    setCss();
    window.addEventListener("resize", onReseize);
  }
}
